import React from 'react';
import PropTypes from 'prop-types';
import { NavPillsBoxContainer } from 'components/common/Styles';
import { NavPills } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { FormulaFieldContainer } from 'components/common/Styles';
import FormulaField from 'features/common/components/formula-field';
import { get, set } from '@totalsoft/change-tracking-react';

const LeasingIncomeSchemaEventFormulasComponent = ({ lens, disabled }) => {
  const { t } = useTranslation();

  return (
    <NavPillsBoxContainer panelTopMargin={1} panelOverflow='visible'>
      <NavPills
        fullWidth
        tabs={[
          {
            label: t('LeasingIncomeSchema.Precondition'),
            content: (
              <FormulaFieldContainer>
                <FormulaField value={lens.precondition |> get} onChange={lens.precondition |> set} disabled={disabled} />
              </FormulaFieldContainer>
            )
          },
          {
            label: t('LeasingIncomeSchema.Formula'),
            content: (
              <FormulaFieldContainer>
                <FormulaField value={lens.formula |> get} onChange={lens.formula |> set} disabled={disabled} />
              </FormulaFieldContainer>
            )
          }
        ]}
      />
    </NavPillsBoxContainer>
  );
};

LeasingIncomeSchemaEventFormulasComponent.propTypes = {
  lens: PropTypes.object,
  disabled: PropTypes.bool
};

export default LeasingIncomeSchemaEventFormulasComponent;
